import { SettingsOptionsModelTransition } from '../domain/settingsOptionsModelTransition';

// 検索条件項目のデフォルトデータ
export const settingsOptionsModelTransitionDefaultValue: SettingsOptionsModelTransition =
  {
    searchCondition: {
      makers: [],
      kiList: [],
      shuGroupList: [],
      shuList: [],
      areas: [],
      halls: [],
      sisTypes: [],
      latestBaseDateForDailySisData: '',
      latestBaseDateForWeeklySisData: '',
      latestBaseDateForMonthlySisData: '',
    },
    fields: {
      transition: [],
      nonTransition: [],
    },
    genres: {
      transition: [],
    },
  };
